import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { environment } from '@env/environment';

@Directive({
    selector: '[appAssetSrc]',
})
export class AssetSrcDirective implements OnInit {
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('appAssetSrc') assetSourceFolder: string;
    constructor(private el: ElementRef) {}
    ngOnInit() {
        this.el.nativeElement.src =
            environment.assetsFolder + this.assetSourceFolder;
    }
}
